import { Module } from 'vuex'
import { RootState } from '@/store'

export interface SystemState {
  pending: boolean
  windowSize: {
    innerWidth: number
    innerHeight: number
  }
  deployedVersion?: string
}

const system: Module<SystemState, RootState> = {
  namespaced: true,
  state: {
    pending: false,
    windowSize: {
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
    },
    deployedVersion: undefined,
  },
  getters: {
    isPending(state) {
      return state.pending
    },
    getWindowSize(state) {
      return state.windowSize
    },
    getDeployedVersion(state) {
      return state.deployedVersion
    },
  },
  mutations: {
    setPending(state, value) {
      state.pending = value
    },
    updateWindowSize(state) {
      state.windowSize = {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      }
    },
    setDeployedVersion(state, version) {
      state.deployedVersion = version
    },
  },
  actions: {
    setPending({ commit }, value: boolean) {
      commit('setPending', value)
    },
    updateWindowSize({ commit }) {
      commit('updateWindowSize')
    },
    setDeployedVersion({ commit }, version: string) {
      commit('setDeployedVersion', version)
    },
  },
}

export default system
